export interface IDeal {
  salesTaxPercentage?: number;
}

export class DealModel implements IDeal {
  salesTaxPercentage?: number;

  constructor(data?: IDeal) {
    if (data) {
      this.salesTaxPercentage = data?.salesTaxPercentage;
    }
  }
}
